import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
export function useSAVPadding() {
    const insets = useSafeAreaInsets();
    return React.useMemo(() => ({
        top: Platform.OS === 'android' ? 30 : insets.top,
        bottom: Platform.OS === 'android' ? 20 : insets.bottom,
    }), [insets.bottom, insets.top]);
}
/** Component that renders a view within the safe area of the device's screen.
 *
 * The safe area is the portion of the screen that is not obscured by system UI elements
 * such as the status bar, navigation bars, or other system-level UI components.
 */
export const SAV = React.memo(function SAV(props) {
    const insets = useSAVPadding();
    const SAVStyle = React.useMemo(() => ({
        ...(props.style ?? {}),
        paddingTop: insets.top,
        paddingBottom: insets.bottom,
        height: '100%',
        width: '100%',
        overflow: props.allowOverflow === true ? 'visible' : 'hidden',
    }), [insets.bottom, insets.top, props.allowOverflow, props.style]);
    return (_jsx(View, { style: SAVStyle, children: _jsx(View, { style: styles.InnerView, children: props.children }) }));
});
const styles = StyleSheet.create({
    InnerView: {
        height: '100%',
        overflow: 'hidden',
    },
});
